import React, { FC, memo } from 'react';
import FormikSelect from '@minecraft.formik-select';
import { useProfileStatusOptions } from '@blocs.filter';
import { FilterData } from '../../shared/types';
import { Label } from '../../shared/styles';

type Props = FilterData;

const ProfileStatus: FC<Props> = ({ name, label }) => {
  const profileStatusOptions = useProfileStatusOptions();

  return (
    <>
      <Label>{label}</Label>
      <FormikSelect name={name} size="small" options={profileStatusOptions} />
    </>
  );
};

export default memo(ProfileStatus);
